<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)"
           [disabled]="disabled || !brandId" [multiple]="multiple"
           [placeholder]="'hx.select.category' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">{{op.title | uiLabel}}</ng-option>
</ng-select>
